export default class PrintUtils {
    constructor(elementId) {
        this.elementId = elementId;
    }

    printElement() {
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '-9999px';
        iframe.style.left = '-9999px';
        document.body.appendChild(iframe);

        const iframeDoc = iframe.contentWindow.document;

        const elementToPrint = document.getElementById(this.elementId);
        if (!elementToPrint) {
            console.error(`Element with ID ${this.elementId} not found.`);
            return;
        }

        // 获取所有样式表
        const styles = Array.from(document.styleSheets)
            .map(styleSheet => {
                try {
                    return Array.from(styleSheet.cssRules)
                        .map(rule => rule.cssText)
                        .join('\n');
                } catch (e) {
                    return '';
                }
            })
            .join('\n');
        iframeDoc.open();
        iframeDoc.write(`
            <html>
                <head>
                    <style>${styles}</style>
                    <style>
                        body {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: 100vh;
                            margin: 0;
                        }
                    </style>
                </head>
                <body>
                    ${elementToPrint.outerHTML}
                </body>
            </html>
        `);
        iframeDoc.close();
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
        };
    }
}